import { layoutConstants } from "@constants";

const initalState = {
  siderCollapsed: true
};

export const layout = (state = initalState, action) => {
  switch (action.type) {
    case layoutConstants.COLLAPSED_CHANGE:
      return {
        ...state,
        siderCollapsed: action.collapsed
      };
    default:
      return state;
  }
};
